<template>
    <div class="main-content">
        <div class="goods-item" @click="goPointsgoodsDetail(item.pgoods_id)">
            <div class="goods-img">
                <div class="img-content">
                    <img :src="item.pgoods_image" />
                </div>
            </div>
            <div class="info-wrap">
                <div class="name-wrap">
                    <div class="goods-name">
                        {{item.pgoods_name}}
                    </div>
                </div>
                <div class="bottom-wrapper">
                    <div class="lineheight-clear">
                        <div class="discount-price">
                                    <span class="text-content unit color-base-text">
                                        <span>{{item.pgoods_points}}</span>
                                    </span>
                            <span class="text-content unit color-base-text font-size-tag">
                                        <span>贡献值</span>
                                    </span>
                        </div>
                    </div>
                    <div class="pro-info">
                        <div class="font-size-activity-tag color-tip">
                            库存{{item.pgoods_storage}}
                        </div>
                        <div class="sale font-size-activity-tag color-tip"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      shareVisible: false,
      goodsList: []
    }
  },
  props: ['item'],
  components: {
  },
  methods: {
      // 积分兑换详情页
      goPointsgoodsDetail (pgoods_id) {
          this.$router.push({ name: 'HomePointsgoodsDetail', query: { pgoods_id: pgoods_id } })
      }
  }
}
</script>

<style scoped lang="scss">
    .main-content{font-size:$subFontSize;line-height: 1.8;}
    .font-size-activity-tag {font-size:$h6!important;}
    .color-tip { color: #909399!important; }
    .color-base-text {color: #ff4544!important;}
    .goods-item {position: relative;background-color: #fff;border-radius: 5px;margin-bottom:.5rem;}
    .goods-item .goods-img {position: relative;overflow: hidden;padding-top: 100%;border-top-left-radius: 5px;border-top-right-radius: 5px}
    .goods-item .goods-img .img-content {width: 100%;height:100%;position: absolute;top: 50%;left: 0;-webkit-transform: translateY(-50%);transform: translateY(-50%)}
    .goods-item .goods-tag {color: #fff;line-height: 1;padding: 4px 8px;position: absolute;border-bottom-right-radius: 5px;top: 0;left: 0;font-size:$fontSize}
    .goods-item .goods-tag-img {position: absolute;border-top-left-radius: 5px;width: 40px;height: 40px;top: 0;left: 0;z-index: 5;overflow: hidden}
    .goods-item .goods-tag-img .img-content {width: 100%;height: 100%}
    .goods-item .info-wrap {padding: 0 13px 13px 13px}
    .goods-item .goods-name {font-size:$subFontSize;line-height: 1.3;overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 1;-webkit-box-orient: vertical;margin-top: 10px;height: 18px}
    .goods-item .discount-price {display: inline-block;font-weight: 700;line-height: 1;margin-top: 8px}
    .goods-item .discount-price .unit {margin-right: 3px}
    .goods-item .pro-info {display: flex;margin-top: 8px}
    .goods-item .pro-info > .view-content {line-height: 1;-webkit-box-flex: 1;-webkit-flex: 1;flex: 1;display: flex;align-items: center}
    .goods-item .pro-info > .view-content:nth-child(2) {-webkit-box-pack: end;-webkit-justify-content: flex-end;justify-content: flex-end}
    .img-content >img{width: 100%;height: 100%;}
    .bottom-wrapper{display: flex;
        .lineheight-clear{flex:1}
    }
</style>
